import { deleteWishlistItemTagAction } from "@/actions/wishlist";
import { useMarket } from "@app/_context";
import useAuth from "@features/auth/hooks/useAuth";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import invalidateWishlistQueries from "../utils/invalidateWishlistQueries";

export default function useDeleteWishlistItemTag() {
  const { market } = useMarket().state;
  const { token } = useAuth();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, isSuccess } = useMutation({
    mutationFn: async ({
      tagId,
      wishlistItemId,
    }: {
      tagId: number;
      wishlistItemId: number;
    }) => {
      if (!token) return;

      return deleteWishlistItemTagAction({
        token,
        tagId,
        wishlistItemId,
        locale: market.serviceLocale,
      });
    },
    onSettled: () => invalidateWishlistQueries(queryClient),
  });

  const deleteWishlistItemTag = useCallback(
    (payload: { tagId: number; wishlistItemId: number }) => {
      mutate(payload);
    },
    [mutate],
  );

  const deleteWishlistItemTagAsync = useCallback(
    (payload: { tagId: number; wishlistItemId: number }) => {
      return mutateAsync(payload);
    },
    [mutateAsync],
  );

  return {
    deleteWishlistItemTag,
    deleteWishlistItemTagAsync,
    isPending,
    isSuccess,
  };
}
